export const environment = {
  apiUrl: `AC_REPLACE_API_URL`,
  crmApiUrl: `AC_REPLACE_CRM_API_URL`,
  jwtIssuerUri: `AC_REPLACE_JWT_ISSUER_URI`,
  oauthClientId: `AC_REPLACE_OAUTH_CLIENT_ID`,
  draftSecret: 'AC_REPLACE_DRAFT_SECRET',
};
